import React, { useState } from 'react'
import { useResponsiveValue } from '@theme-ui/match-media'

import {
  PillarStyled,
  PillarMaskStyled,
  PillarMaskContentStyled,
  PillarFrontStyled,
  PillarFrontIconStyled,
  PillarFrontTitleStyled,
  PillarFrontArrowStyled
} from './styles'
import { PillarProps } from './types'
import ImageStatic from './../../atoms/ImageStatic'
import { IconArrowBold } from './../../../assets/svg/index'

const Pillar: React.FC<PillarProps> = ({ title, icon, content }) => {
  const isTablet = useResponsiveValue([false, true, true, true], {
    defaultIndex: 0
  })

  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    if (!isTablet) {
      if (!isOpen) {
        setIsOpen(true)
      } else {
        setIsOpen(false)
      }
    }
    return
  }

  return (
    <PillarStyled isOpened={isOpen} onClick={handleClick}>
      <PillarMaskStyled>
        <PillarMaskContentStyled
          as="p"
          sx={{
            variant: 'bodyMontserrat6'
          }}
        >
          {content}
        </PillarMaskContentStyled>
      </PillarMaskStyled>
      <PillarFrontStyled>
        <PillarFrontIconStyled>
          <ImageStatic image={icon} />
        </PillarFrontIconStyled>
        <PillarFrontTitleStyled
          as="h4"
          sx={{
            variant: 'bodyMontserrat26'
          }}
        >
          {title}
        </PillarFrontTitleStyled>
        <PillarFrontArrowStyled>
          <IconArrowBold />
        </PillarFrontArrowStyled>
      </PillarFrontStyled>
    </PillarStyled>
  )
}

export default Pillar
